import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'core-page',
  template: 'CoreComponent'
})
export class CorePage implements OnInit, OnDestroy, OnChanges {

  protected initialized: boolean = false;
  protected busy: boolean = false;

  defaultLabel: string = "";


  constructor(
      protected route: ActivatedRoute,
  ) {
  }



  /**
   * Initialization.
   */
  ngOnInit(): void {
    this.preInit();

    // log the visit
    this.logVisit();

    //register page
    this.setActivePage();

    //set page title in browser tab
    this.setActiveTitle();

    // update page context
    this.updatePageContext();

  }

  protected updatePageContext() {

  }

  /**
   * Log Visit.
   * @protected
   */
  protected logVisit() {

  }

  protected setActivePage() {

  }

  protected setActiveTitle() {

  }


  protected preInit() {

  }


  ngOnChanges(changes: SimpleChanges): void {

  }

  ngOnDestroy() {

  }

  isBreadcrumbVisible(): boolean {
    return false;
  }

  isConfigurationPage(): boolean {
    return false;
  }

}
